import React from 'react';
import PlayerInfoStats from '../playerInfoStats';
import TotalPoints from '../totalPoints';

const PlCardInfo = ({ data }) => {
  return (
    <>
      <div className='si-plCardInfo'>
        <div className='si-plCardInfo__grid'>
          <div className='si-plCardInfo__grid-lhs'>
            <PlayerInfoStats
              title='Picked by'
              data={typeof data?.sel_per === 'number' ? `${data?.sel_per}%` : '-'}
            />
          </div>
          <div className='si-plCardInfo__grid-rhs'>
            <PlayerInfoStats
              title='Total Pts'
              data={typeof data?.ov_pts === 'number' ? data?.ov_pts : '-'}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PlCardInfo;
